import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import axios from "axios";
import { AddSubscription, ModifySubscription } from "../Components/modalPopup";
import {
  FaRegListAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaTrashAlt,
  FaClock,
  FaChevronDown,
} from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;

const statusOptions = [
  { value: "tutti", label: "Tutti", icon: <FaRegListAlt /> },
  {
    value: "attivo",
    label: "Attivo",
    icon: <FaCheckCircle className="text-green-500" />,
  },
  {
    value: "scadenza",
    label: "Scadenza",
    icon: <FaClock className="text-yellow-500" />,
  },
  {
    value: "cancellato",
    label: "Cancellato",
    icon: <FaTrashAlt className="text-red-700" />,
  },
  {
    value: "scaduto",
    label: "Scaduto",
    icon: <FaExclamationTriangle className="text-red-500" />,
  },
];

const CustomSelect = ({ selectedStatus, handleFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Riferimento per il dropdown

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Chiudi il dropdown se si clicca al di fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Aggiungi l'evento mousedown
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Rimuovi l'evento al dismount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex items-center justify-between w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        onClick={toggleDropdown}
      >
        <span className="flex items-center">
          {
            statusOptions.find((option) => option.value === selectedStatus)
              ?.icon
          }
          <span className="ml-2">
            {
              statusOptions.find((option) => option.value === selectedStatus)
                ?.label
            }
          </span>
        </span>
        <FaChevronDown className="w-5 h-5 text-gray-500" />
      </button>
      {isOpen && (
        <ul className="absolute z-10 w-auto mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
          {statusOptions.map((option) => (
            <li
              key={option.value}
              className={`flex items-center p-2 cursor-pointer hover:bg-gray-100 ${
                selectedStatus === option.value ? "bg-gray-200" : ""
              }`}
              onClick={() => {
                handleFilterChange({ target: { value: option.value } });
                setIsOpen(false);
              }}
            >
              <span className="mr-2">{option.icon}</span>
              <span className="flex-1">{option.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const ManageSubscription = () => {
  const [abbonati, setAbbonati] = useState([]);
  const [users, setUsers] = useState([]);
  const [tipiAbbonamento, setTipiAbbonamento] = useState([]);

  const [error, setError] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("tutti");

  const [editError, setEditError] = useState(null);
  const [editUserId, setEditUserId] = useState(null);
  const [userData, setUserData] = useState({}); // Inizializza i dati utente
  const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);
  const [isAddSubscriptionModalOpen, setIsAddSubscriptionModalOpen] =
    useState(false);

  const handleOpenAddUserModal = () => setIsAddSubscriptionModalOpen(true); //APRI MODALE AGGIUNTA UTENTE
  const handleCloseAddSubscriptionModal = () =>
    setIsAddSubscriptionModalOpen(false); //CHIUDI MODALE AGGIUNTA UTENTE

  const formatDateForInput = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("/"); // Split the date by hyphen

    return `${year}-${month}-${day}`; // Re-arrange to YYYY-MM-DD format
  };
  /* Fetch abbonati e utenti*/
  useEffect(() => {
    const fetchUsers = async () => {
      axios.defaults.withCredentials = true;
      try {
        const response = await axios.get(`${API_URL}/admin/subscriptions`);
        console.log("Response:", response.data);
        setAbbonati(response.data.abbonati);
        setUsers(response.data.utenti);
        setTipiAbbonamento(response.data.prodotti);
        setFilteredUsers(response.data.abbonati);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError("Non sei autorizzato ad accedere a questa pagina.");
        } else {
          console.error("Error fetching users:", error);
          setError("Si è verificato un errore nel recupero degli utenti.");
        }
      }
    };
    fetchUsers();
  }, []);

  /*RECUPERA DATI ABBONAMENTO PER MODIFICA */
  useEffect(() => {
    const fetchData = async () => {
      if (!editUserId) return;

      axios.defaults.withCredentials = true;
      try {
        const response = await axios.get(
          `${API_URL}/admin/getSubscriptionData/${editUserId}`
        );

        console.log("Response:", response.data);
        if (response.data) {
          console.log("QUI");
          setUserData({
            id: response.data.id_utente,
            nome: response.data.nome,
            cognome: response.data.cognome,
            email: response.data.email,
            num_tel: response.data.num_tel,
            indirizzo: response.data.indirizzo,
            comune: response.data.comune,
            provincia: response.data.provincia,
            cap: response.data.cap,
            ruolo: response.data.ruolo,
            id_prodotto: response.data.id,
            titolo: response.data.titolo,
            data_inizio: formatDateForInput(
              new Date(response.data.data_inizio).toLocaleDateString()
            ),
            data_fine: formatDateForInput(
              new Date(response.data.data_fine).toLocaleDateString()
            ),
            tipo: response.data.tipo,
            status: response.data.status,
          });

          console.log("User data set:", response.data);
          // Ora che i dati sono stati recuperati correttamente, apri il modale
          handleOpenModifyModal(); // Apri il modale qui
        } else {
          console.error("Nessun utente trovato."); // Aggiungi un messaggio di errore se l'utente non viene trovato
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati utente:", error);
        setError(
          "Si è verificato un errore nel recupero dei dati dell'utente."
        );
      }
    };

    fetchData(); // Chiama fetchData quando editUserId cambia
  }, [editUserId]); // useEffect dipende solo da editUserId

  /* APRI MODALE MODIFICA ABBONAMENTO */
  const handleOpenModifyModal = () => setIsModifyModalOpen(true);

  /* CHIUDI MODALE MODIFICA UTENTE */
  const handleCloseModifyModal = () => {
    setIsModifyModalOpen(false);
    setEditUserId(null); // Reset dell'ID utente
    setEditError(null); // Reset dell'errore
    setUserData({ nome: "", cognome: "", email: "", num_tel: "", ruolo: "" }); // Reset dei dati utente
  };

  /*SALVA DATI ABBONAMENTI*/
  const handleSaveModifyClick = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/admin/subscriptions/${editUserId}`,
        userData
      );

      // Controlla se la risposta è positiva
      if (response.status === 200) {
        setAbbonati((prevUsers) =>
          prevUsers.map((user) =>
            user.id_utente === editUserId ? { ...user, ...userData } : user
          )
        );
        handleCloseModifyModal(); // Chiudi il modale dopo il salvataggio
      }
    } catch (error) {
      // Log dell'errore
      console.error("Error updating user:", error);

      // Mostra un messaggio di errore più specifico
      const errorMessage =
        error.response?.data?.message ||
        "Si è verificato un errore nell'aggiornamento dei dati dell'utente.";
      setEditError(errorMessage);
    }
  };

  useEffect(() => {
    console.log("Editing user ID:", editUserId); // Logga l'ID utente in modifica
  }, [editUserId]);

  useEffect(() => {
    console.log("TIPI ABBONAMENTO:", tipiAbbonamento); // Logga l'ID utente in modifica
  }, [tipiAbbonamento]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    applyFilter(selectedStatus, event.target.value);
  };
  const handleFilterChange = (event) => {
    setSelectedStatus(event.target.value);
    applyFilter(event.target.value, searchTerm); // Applica il filtro anche quando cambia lo stato
  };

  useEffect(() => {
    applyFilter(selectedStatus, searchTerm);
  }, [abbonati, searchTerm, selectedStatus]);

  const applyFilter = (status, search) => {
    const filteredData = abbonati.filter((item) => {
      const nome = item.nome || "";
      const cognome = item.cognome || "";
      const email = item.email || "";

      return (
        nome.toLowerCase().includes(search.toLowerCase()) ||
        cognome.toLowerCase().includes(search.toLowerCase()) ||
        email.toLowerCase().includes(search.toLowerCase())
      );
    });

    if (status === "tutti") {
      setFilteredUsers(filteredData); // Mostra tutti gli utenti che corrispondono al termine di ricerca
    } else {
      const filteredByStatus = filteredData.filter(
        (user) => user.status === status
      );
      setFilteredUsers(filteredByStatus); // Filtra ulteriormente in base allo stato selezionato
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "attivo":
        return "text-green-500";
      case "scadenza":
        return "text-yellow-500";
      case "cancellato":
        return "text-red-700";
      case "scaduto":
        return "text-red-500";
      default:
        return "text-gray-500";
    }
  };

  const handleDownloadAbbonati = async () => {
    /*
    alert("PROVA");
    axios.defaults.withCredentials = true;

    const response = await axios.get(`${API_URL}/exportUsers`);
    console.log(response);*/

    try {
      const response = await axios.get(`${API_URL}/exportUsers`, {
        responseType: "blob", // Imposta il tipo di risposta come blob
      });

      // Creazione di un URL temporaneo per il blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Creazione di un link per forzare il download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users.xlsx"); // Nome del file da scaricare
      document.body.appendChild(link);

      link.click(); // Simula il click per avviare il download

      // Rimozione del link temporaneo
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Errore durante il download del file", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-100">
        {/* Sidebar */}
        <Sidebar />
        <div className="flex-1 p-6">
          <h1 className="text-3xl font-bold mb-6 text-gray-800">
            Gestione Abbonamenti
          </h1>

          <div className="flex justify-between items-center mb-6">
            <div className="flex space-x-4">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
                placeholder="Cerca utente"
              />
              {/* Selettore per filtrare lo stato */}

              <CustomSelect
                selectedStatus={selectedStatus}
                handleFilterChange={handleFilterChange}
              />
              <button
                className="p-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-200"
                onClick={handleDownloadAbbonati}
              >
                Scarica abbonati
              </button>
            </div>

            <div className="flex space-x-4">
              <button
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-200"
                onClick={handleOpenAddUserModal}
              >
                Aggiungi abbonamento
              </button>
              <button className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition duration-200">
                Rimuovi abbonamento
              </button>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                  <th className="py-3 px-4 border-b">ID</th>
                  <th className="py-3 px-4 border-b">Nome</th>
                  <th className="py-3 px-4 border-b">Email</th>
                  <th className="py-3 px-4 border-b">Data inizio</th>
                  <th className="py-3 px-4 border-b">Data fine</th>
                  <th className="py-3 px-4 border-b">Stato</th>
                  <th className="py-3 px-4 border-b">Tipo</th>
                  <th className="py-3 px-4 border-b">Azioni</th>
                </tr>
              </thead>
              {filteredUsers.length > 0 ? (
                <tbody className="text-gray-700 text-md">
                  {filteredUsers.map((user) => (
                    <tr
                      key={user.id_utente}
                      className="hover:bg-gray-100 transition duration-200"
                    >
                      <td className="py-2 px-4 border-b border-x">
                        {user.id_utente}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {`${user.cognome || ""} ${user.nome || ""}`.trim()}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.email}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.data_inizio
                          ? new Date(user.data_inizio).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.data_fine
                          ? new Date(user.data_fine).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td
                        className={`py-2 px-4 border-b border-x ${getStatusColor(
                          user.status
                        )}`}
                      >
                        {user.status}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.tipo === "onetime"
                          ? "Rinnovo manuale"
                          : "Rinnovo automatico"}
                      </td>
                      <td className="py-2 px-4 border-b">
                        <button
                          className="bg-blue-500 text-white py-1 px-2 rounded hover:bg-blue-600 transition duration-200"
                          onClick={() => setEditUserId(user.id_utente)}
                        >
                          Modifica
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="8" className="py-4 text-center text-gray-500">
                      Nessun risultato trovato.
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>

          <ModifySubscription
            userData={userData}
            tipiAbbonamento={tipiAbbonamento}
            onChange={(updatedData) => setUserData(updatedData)}
            isOpen={isModifyModalOpen}
            onClose={handleCloseModifyModal}
            onConfirm={handleSaveModifyClick}
            errorMessage={editError}
            setErrorMessage={setEditError}
            title="Modifica Utente"
            message="Modifica i dati dell'utente."
            confirmLabel="Salva"
            cancelLabel="Annulla"
            iconColor="text-blue-600"
            iconBgColor="bg-blue-100"
            confirmBgColor="bg-blue-500"
            confirmHoverBgColor="hover:bg-blue-600"
            confirmTextColor="text-white"
            cancelBgColor="bg-white"
            cancelHoverBgColor="hover:bg-gray-100"
            cancelTextColor="text-gray-900"
          />
          <AddSubscription
            users={users}
            tipiAbbonamento={tipiAbbonamento}
            onChange={(updatedData) => setUserData(updatedData)}
            isOpen={isAddSubscriptionModalOpen}
            onClose={handleCloseAddSubscriptionModal}
            onConfirm={handleSaveModifyClick}
            errorMessage={editError}
            setErrorMessage={setEditError}
            title="Aggiungi Abbonamento"
            message="Inserisci i dati dell'abbonato."
            confirmLabel="Aggiungi"
            cancelLabel="Annulla"
            iconColor="text-blue-600"
            iconBgColor="bg-blue-100"
            confirmBgColor="bg-blue-500"
            confirmHoverBgColor="hover:bg-blue-600"
            confirmTextColor="text-white"
            cancelBgColor="bg-white"
            cancelHoverBgColor="hover:bg-gray-100"
            cancelTextColor="text-gray-900"
          />
        </div>
      </div>
    </div>
  );

  // Helper function to get status color
};

export default ManageSubscription;
